import { TypeContainerSkeleton } from "#/types/contentful"
import { useContentfulEntry } from "#/lib/contentful/hooks/useContentfulEntry"
import { useConditionDepsStatus } from "#/services/contentful/hooks/use-contentful-conditions"
import { StaticAssetID } from "#/lib/contentful/contentfulClient"
import useBenefit from "#/components/dynamic-content/hooks/useGetBenefit"
import { ProgramType } from "#/lib/carrot-api/types/Benefit"

export function useContentfulBenefitHighlights() {
  const {
    data: container,
    isLoading: isEntryLoading,
    isError: isEntryError
  } = useContentfulEntry<TypeContainerSkeleton>(StaticAssetID.HOME_PAGE_BENEFIT_HIGHLIGHTS_CONTAINER_ID)
  const { isLoading: areConditionDepsLoading, isError: isConditionDepsError } = useConditionDepsStatus()
  const { data: benefit, isLoading: isBenefitLoading, isError: isBenefitError } = useBenefit()
  const programType = benefit?.program.type
  const programTypeAllowsBenefitHighlight = programType === ProgramType.PRO || programType === ProgramType.CORE

  const isLoading = isEntryLoading || areConditionDepsLoading || isBenefitLoading
  const isError = isEntryError || isConditionDepsError || isBenefitError
  const content = container?.fields?.content ?? null

  return { content, programTypeAllowsBenefitHighlight, isLoading, isError }
}
